import Environment from "types/enums/Environment";

// REPLACE: replace with cookie name prefix for project
export const SESSION_COOKIE_NAME_PREFIX = "sps-session";

export default function getSessionCookieName(environment: Environment) {
  return `${SESSION_COOKIE_NAME_PREFIX}-${environment}`;
}
